// extracted by mini-css-extract-plugin
export default {"item":"SliderItem_item__LeTkb","active":"SliderItem_active__noQ9I","price":"SliderItem_price__UtV4z","sessions":"SliderItem_sessions__Duj3W"};